module.exports = __webpack_public_path__ + "static/media/3.fae2e3fc.png";